import { Component, Output, OnInit, EventEmitter } from "@angular/core";
import { Usuario, TipoUsuario } from "../../../../interfaces/usuario";
import { EntidadResponsable } from "./entidad-responsable";
import { FormControl, Validators } from "@angular/forms";
import { UsuarioService } from "../../../../providers/usuario.service";
import { Telefono } from "../../../../components/telefono/telefono.component";

@Component({
  selector: 'app-entidad-responsable',
  templateUrl: './entidad-responsable.component.html',
  styleUrls: ['./entidad-responsable.component.scss']
})
export class EntidadResponsableComponent implements OnInit {
  entidadResponasble: EntidadResponsable;
  usuarios: Usuario[] = [];
  cargandoUsuarios: boolean = false;
  @Output() onEntidadResponsableInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  usuarioFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private usuarioService: UsuarioService
  ) { }

  ngOnInit() {
    this.entidadResponasble = new EntidadResponsable();
    this.traerUsuarios();
  }

  traerUsuarios(): void {
    this.cargandoUsuarios = true
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }

        this.cargandoUsuarios = false;
      },
      error => {
        this.cargandoUsuarios = false;
      }
    );
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onEntidadResponsableInput.emit();
  }

  compararUsuario(usuario1: any, usuario2: any): boolean | null { // le dice al select como comparar
    if (usuario1 && usuario2) {
      return usuario1.IdUsuario == usuario2.IdUsuario;
    }

    return false;
  }

  getEntidadResponsable(): EntidadResponsable {
    // revisar las validaciones
    if (this.usuarioFormControl.hasError('required')) {
      this.usuarioFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.entidadResponasble;
  }
}
